export enum Color {
  Secondary500 = '#00CDFF',
  Error500 = '#FF4B78',
  Warning500 = '#FF8700',
  Success500 = '#00D2A0',
  Yellow = '#FCC939',
  Tertiary500 = '#06E4F9',
  White = '#FFFFFF',
  Black = '#000000',

  Primary100 = '#F4EFFF',
  Primary200 = '#DBCBFF',
  Primary300 = '#C2A7FF',
  Primary400 = '#AA83FF',
  Primary500 = '#915FFF',
  Primary600 = '#7749DD',
  Primary700 = '#6036BB',
  Primary800 = '#4A2699',
  Primary900 = '#361877',
  Primary1000 = '#240E55',

  Blue100 = '#E5F4FF',
  Blue200 = '#B7DFFF',
  Blue300 = '#89CBFF',
  Blue400 = '#5CB7FF',
  Blue500 = '#2EA3FF',
  Blue600 = '#0089F4',
  Blue700 = '#0072CB',
  Blue800 = '#005BA2',
  Blue900 = '#00447A',
  Blue1000 = '#002D51',

  Yellow100 = '#FFF8C5',
  Yellow200 = '#FAE17D',
  Yellow300 = '#EAC54F',
  Yellow400 = '#D4A72C',
  Yellow500 = '#BF8700' /* BEFORE YELLOW */,
  Yellow600 = '#9A6700',
  Yellow700 = '#7D4E00',
  Yellow800 = '#633C01',
  Yellow900 = '#4D2D00',
  Yellow1000 = '#3B2300',

  Orange100 = '#FFF1E5',
  Orange200 = '#FFD8B5',
  Orange300 = '#FFB77C',
  Orange400 = '#FB8F44',
  Orange500 = '#E16F24',
  Orange600 = '#BC4C00',
  Orange700 = '#953800',
  Orange800 = '#762C00',
  Orange900 = '#5C2200',
  Orange1000 = '#471700',

  Red100 = '#FFEBE9',
  Red200 = '#FFCECB',
  Red300 = '#FFABA8',
  Red400 = '#FF8182',
  Red500 = '#FA4549',
  Red600 = '#CF222E',
  Red700 = '#A40E26',
  Red800 = '#82071E',
  Red900 = '#660018',
  Red1000 = '#4C0014',
  Green100 = '#DAFBE1',
  Green200 = '#ACEEBB',
  Green300 = '#6FDD8B',
  Green400 = '#4AC26B',
  Green500 = '#2DA44E',
  Green600 = '#1A7F37',
  Green700 = '#116329',
  Green800 = '#044F1E',
  Green900 = '#003D16',
  Green1000 = '#002D11',

  Gray100 = '#F6F8FA',
  Gray200 = '#EAEEF2',
  Gray300 = '#D0D7DE',
  Gray400 = '#AFB8C1',
  Gray500 = '#8C959F',
  Gray600 = '#6E7781',
  Gray700 = '#57606A',
  Gray800 = '#424A53',
  Gray900 = '#32383F',
  Gray1000 = '#24292f',

  Kakao = '#FEE500',
  Naver = '#03C75A',
  Twitter = '#1DA1F2',

  DirittoGreen = '#CBDFC7',
  SepiaBg = '#F6F1E5',
  DarkGrayBg = '#484848',
  DarkBg = '#1A1A1A',
  DarkGrayTxt = '#D4D4D4',
  BlackTxt = '#ABABAB',
}
